import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("aura_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiError(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Qualcosa è andato storto. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  if (typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const photoUrl = (p) => (!p ? "" : p.startsWith("http") ? p : `${API}/files/${p}`);

export const CITIES = ["Milano", "Roma", "Firenze", "Torino", "Bologna", "Venezia", "Napoli"];
export const SEO_CITIES = ["Milano", "Varese", "Roma", "Napoli"];
export const citySlug = (c) => c.toLowerCase();
export const EVENT_COST = 5;
export const URGENT_COST = 3;
export const UNLOCK_COST = 10;
export const CATEGORIES = ["Hostess", "Modella", "Accompagnatrice", "Immagine", "VIP Event"];
export const LANGUAGES = ["Italiano", "Inglese", "Francese", "Spagnolo", "Tedesco", "Russo", "Cinese", "Arabo"];

export const formatCompensation = (e) =>
  e.compensation ? `€ ${e.compensation}${e.compensation_unit ? ` / ${e.compensation_unit}` : ""}` : "Da concordare";

export const formatDate = (d) => {
  if (!d) return "";
  try {
    return new Date(d).toLocaleDateString("it-IT", { day: "numeric", month: "long", year: "numeric" });
  } catch {
    return d;
  }
};

export const lastSeenInfo = (iso) => {
  if (!iso) return { online: false, label: "" };
  const m = Math.floor((Date.now() - new Date(iso).getTime()) / 60000);
  if (m < 10) return { online: true, label: "Online ora" };
  if (m < 60) return { online: false, label: `Online ${m} min fa` };
  if (m < 1440) return { online: false, label: `Online ${Math.floor(m / 60)} h fa` };
  const d = Math.floor(m / 1440);
  return { online: false, label: d === 1 ? "Online ieri" : `Online ${d} g fa` };
};
